import { Transfer } from "antd"
import { useEffect, useMemo, useState } from "react";
import { useAppContext } from "../../../../../system/providers/appContextProvider";
import { DiscountProgramProvider } from "../../../../../Services/DataProviders/DiscountProgramProvider";
import { IDiscountProgramFormViewDTO } from "../../../../../libs/coreapi-dto/dirs/discountProgram";
import { Spinner } from "../../../../../components/spiner/Spinner";
import { ITransferActionsProps, RecordType } from "../../interface";

const TransferActions: React.FC<ITransferActionsProps> = ({
    value = [],
    onChange,
    data
}) => {
    const appCtx = useAppContext()
    const discountProgramProvider = new DiscountProgramProvider(appCtx.coreApiService);

    const [allActionsData, setAllActionsData] = useState<IDiscountProgramFormViewDTO[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
   
    const gridFilterActions: IGridFilter = {
        numberPerPage: 15,
        pageNumber: 1,
        columnFilters: [
            {
                name: "deleted",
                operator: "Eq",
                value: false,
            },
            {
                name: "idContractorGlobal",
                operator: "Eq",
                value: data?.idContractorGlobal,
            }
        ]
    };
    
    const transformDataToTransferFormat = (actions: IDiscountProgramFormViewDTO[]): RecordType[] => {
        return actions.map(action => ({
            key: action.idGlobal,
            title: action.name || 'Без названия',
        }));
    };

    const filteredTransferData = useMemo(() => {

        const allData = transformDataToTransferFormat(allActionsData);

        return allData.filter(item =>
            !value.includes(item.key))
            
    }, [allActionsData, value]);

    const selectedActionsInfo = useMemo(() => {
        return allActionsData
            .filter(action =>
                value.includes(action.idGlobal)
            )
            .map(action => ({
                key: action.idGlobal,
                title: action.name || 'Без названия',
            }));
    }, [allActionsData, value]);

    const transferDataSource = useMemo(() => {
        return [...filteredTransferData, ...selectedActionsInfo];
    }, [filteredTransferData, selectedActionsInfo]);

    useEffect(() => {
        setIsSubmitting(true)
        discountProgramProvider.getView(gridFilterActions, (data, totalCount) => {
            if (totalCount > gridFilterActions.numberPerPage) {
                const allDataFilter = { ...gridFilterActions, numberPerPage: totalCount, pageNumber: 1 };
                discountProgramProvider.getView(allDataFilter, (data) => {
                    setAllActionsData(data);
                    setIsSubmitting(false);
                });
            } else {
                setAllActionsData(data);
                setIsSubmitting(false);
            }
            setAllActionsData(data);
            setIsSubmitting(false);
        })
    }, [])

    const filterOption = (inputValue: string, option: RecordType) =>
        option.title.toLowerCase().includes(inputValue.toLowerCase())

    const handleChange = (newTargetKeys: string[]) => {
        if (onChange) {
            onChange(newTargetKeys);
        }
    };

    if (isSubmitting) {
        return <Spinner/>;
    }

    return (
        <Transfer
            dataSource={transferDataSource}
            targetKeys={value}
            onChange={handleChange}
            render={item => `${item.title}`}
            showSearch
            filterOption={filterOption}
            listStyle={{
                width: 900,
                height: 500
            }}
            pagination
        />
    )
}

export default TransferActions